import { Component,OnInit,Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PlanogramStateService } from 'src/services/planogram-state.service';

@Component({
  selector: 'user-support-pop-up',
  templateUrl: './user-support-pop-up.component.html',
  styleUrl: './user-support-pop-up.component.css'
})
export class UserSupportPopUpComponent {
  subject:string=""
  description:string=""
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  private dialogRef: MatDialogRef<UserSupportPopUpComponent>,
  private planogramState:PlanogramStateService
 ) {
   }

  submitQuery(){
    let payload:any={}
    payload.subject=this.subject
    payload.description=this.description
    this.planogramState.saveBottlerQueries(payload)
    this.dialogRef.close()
  }

  closeSupportDialog(){
    this.dialogRef.close()
  }
}
